//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axiosApi from '@/request/index'
import {getUrlparams,countDownTimeFunc} from '@/utils/util.js'
import footerNav from '@/components/footerNav'
import { Dialog,Toast } from 'vant';

export default {
  name: "productCertificates",
  components: {
    footerNav
  },
  data() {
    return {
      value:''
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    onSearch(){

    },
    toDetail(){
      this.$router.push({name:'productCertificateDetail'})
    },
    toAdd(){
      this.$router.push({name:'productCertificateAdd'})
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/productCertificates/index.vue